import { Injectable } from '@angular/core';
import { SchedulerAction } from 'rxjs';
import {defined} from './appDefs';

declare var
window:any;

@Injectable({
  providedIn: 'root'
})
export class TimeKeeperService {

  private beats;
  private time;
  private schedule;
  private nameSched;
  private bars;
  private tempo;


  ctx :AudioContext;
  private halfBeatSchedule:Array <{ loop:number,beat:number,done:boolean,presetCb:any,Cb:any,postCb:any,almostFinishedCb:any , name:string}>;
  private beatSchedule:Array <{loop:number,beat:number,done:boolean,presetCb:any,Cb:any,postCb:any,almostFinishedCb:any , name:string}>;
  private measureSchedule:Array <{loop:number,beat:number,done:boolean,presetCb:any,Cb:any,postCb:any,almostFinishedCb:any , name:string}>;
  private scheduleTempo=0;
 
  private running=false;
 private teEvent;
 private waevent=null;
   
private scheduleTime;
private lastBeatTime;
private currentBeat;
private currentMeasure=0;

private beatsPerMeasure=1;
private beatDuration;
private base=0.2;
constructor()
{
    this.halfBeatSchedule=null;
  this.beatSchedule=null;
  this.measureSchedule=null;
  this.currentBeat=0;
  this.beatSchedule=[];
  this.halfBeatSchedule=[];
  this.measureSchedule=[];
    this.beats=0;
   this.time=0;
   this.tempo=120;
   this.schedule=[];
  this.nameSched={};
  this.initServ();
}
initServ()
  {
	  
 
  //this.ctx=window.Howler.ctx;
  this.ctx=window.Howler.ctx;



 
  };
varyTempo (n)
{
	var newTempo=n+this.tempo;
	if ((newTempo >=10 ) && (newTempo <= 700))
	{
		this.tempo=newTempo;
		this.tempoChange(null);
	}
}
 tempoHalf ()
  {
	  
	  this.tempo =Math.floor(this.tempo/2);
      this.tempoChange(null);
  }
  
 
  tempoChange(tempo)
  {
    if (tempo)
      this.tempo=tempo;
    this.teEvent=null;
      if (tempo && this.running)
      {
        
      
      
      }
  }
  getTempo()
  {
    return (this.tempo);
  }
  debounceTempoChange()
  {
    if (this.teEvent)
    return;
    else
    this.teEvent=setTimeout(this.tempoChange.bind(this),200)
  }

addHalfBeatSched(sched:any) :string
{
 if (sched && sched.name)
 {
  let exists=this.halfBeatSchedule.filter(a=>a.name==sched.name );
  if (exists[0])
  {
    return ("Already Exists");
  }

 
  this.halfBeatSchedule.push(sched)
  return "";
}
return ("Invalid Param");
};
removeHalfBeatSched(name:string)
{
  let exists=this.halfBeatSchedule.map((a,index)=>{
   if (a.name==name )
   {
     this.halfBeatSchedule.splice(index,1);
   }});
 
}

addBeatSched(sched:any) :string
{
 if (sched && sched.name)
 {
  let exists=this.beatSchedule.filter(a=>a.name==sched.name );
  if (exists[0])
  {
  let exists=this.beatSchedule.map((a,index)=>{
   if (a.name ==sched.name )
   {
     this.beatSchedule.splice(index,1);
   }});
   
  }

 
  this.beatSchedule.push(sched)
  return "";
}
return ("Invalid Param");
};
removeBeatSched(name:string)
{
  let exists=this.beatSchedule.map((a,index)=>{
   if (a.name==name )
   {
     this.beatSchedule.splice(index,1);
   }});
  if (this.beatSchedule.length==0 && this.halfBeatSchedule.length==0) // finally check for all schedule... now only full beat
  {
    this.beatFun=null;
  }
}



                
getLag  ()
{
var ms=Math.floor(60*1000/this.tempo);
console.log('MS ',ms);
let lag=this.ctx.currentTime - (this.lastBeatTime *1000 +ms );

return lag;
}
halfBeat=0;
runHalfBeatClock ()
/* run scheduled tasks in shedule */
{

                 
                  
                  // remove already done
                  if (this.halfBeatSchedule)
                  {
                    this.halfBeatSchedule=this.halfBeatSchedule.filter(a=> !a.done)
                  }        
                  this.halfBeatSchedule && this.halfBeatSchedule.forEach(

                    sched=>{
                    
                      if ((!defined(sched.done) || (sched.done==null) || !sched.done) && ((sched.beat==this.halfBeat) || sched.beat==-1))
                      {
                            
                      sched.Cb && sched.Cb(this.currentBeat,this.currentMeasure, this.tempo, sched);
                      
                     
                      if (!sched.loop|| sched.loop==0)
                      sched.done=true;
                      else
                      
                      sched.loop--;
                      
                      }
                        
                      });
                    ;
                
                    if (this.halfBeat%2 ==0) // not half beat
                    {
                      
                      if (this.beatSchedule)
                      {
                        //this.beatSchedule=this.beatSchedule.filter(a=> !a.done)
                      }  
                    this.beatSchedule && this.beatSchedule.forEach(sched=>{
                      
                             if ((!defined(sched.done) || (sched.done==null) || !sched.done) && ((sched.beat==this.currentBeat) || sched.beat==-1))
                      
                           
                              {
                                    
                             sched.Cb &&  sched.Cb(this.currentBeat,this.currentMeasure, this.tempo, sched);
                              
                             
                              if (!sched.loop || sched.loop==0)
                              sched.done=true;
                              else
                              
                              sched.loop--;
                              
                              }
                                
                              });
                    
               
                      if ((this.currentBeat % this.beatsPerMeasure)==0)
                    {
                        
                      this.currentMeasure++;
                       this.measureSchedule.forEach(sched=>{
                      
                        if (!sched.done && ((sched.beat==this.currentBeat) || sched.beat==-1))
                        {
                              
                        sched.Cb && sched.Cb(this.currentMeasure, this.tempo, sched);
                        
                       
                        if (!sched.loop || sched.loop==0)
                        sched.done=true;
                        else
                        
                        sched.loop--;
                        
                        }
                          
                        });
                             

                    }
                      this.currentBeat++;
                      if ((this.currentBeat % this.beatsPerMeasure)==0)
                      this.currentBeat=0;
                    
                    }
                    this.lastBeatTime=this.ctx.currentTime;
                    
                     this.halfBeat++;
                         if ((this.halfBeat % (this.beatsPerMeasure*2))==0)
                      this.halfBeat=0;
                    
                   
                    
                    

                                                    
        
       

}
nextBeat()
{
    if ((this.currentBeat+1)%this.beatsPerMeasure==0)
        {
        return 0;
        }
    else
        return this.currentBeat+1;
        
}
        
/*

Service.doubleTempo=function (max)
{
  if (Service.tempo * 2 > max)
  {
    Service.tempo=max;

  }
  else
  {
    Service.tempo =Service.tempo*2;
  }
  Service.tempoChange();

}
*/
stopBeatClock (){
                                if (this.waevent)
                                
                                this.waevent.clear();
                                this.waevent=null;
                          };
restartBeatClock (tempo,bpm,startMeasure,startBeat)
                                {
                                  if (tempo)
                                  {
                                    this.tempo=tempo;
                                  }
                                  else 
                                  if (!this.tempo )
                                  return;
                                  if (bpm>0)
                                  this.beatsPerMeasure=bpm;
                                  if (!this.beatsPerMeasure)
                                    this.beatsPerMeasure=8;
                                      if (!(defined(this.beatsPerMeasure)))
                                    this.beatsPerMeasure=8;
                                  if (startMeasure)
                                  {
                                    this.currentMeasure=startMeasure;
                                  }
                                  if (startBeat!=null)
                                  {
                                    this.currentBeat=startBeat;
                                  }
                                  this.beatDuration=60/this.tempo*1000;
                                this.stopBeatClock();
                                this.currentBeat=startBeat;
                                //this.beatsPerMeasure=bpm;
                                if (!this.ctx)
                                this.ctx=window.Howler.ctx;

                                this.ctx.resume();
   
                                this.halfBeat=this.currentBeat*2;
                             
                                this.beatFun=this.runHalfBeatClock.bind(this);
                                if (!this._started)
                                {
                                 this._started=true;
                                
                                 this.runTick(null);
                                }
                               
                                }
                                ;

// we run our clock on half beat
_started=false;   
beatFun=null;
beatInterval=null;
beatTime=0;
halfBeeatFun=null;   
beatTimeout=null;

runTick (timeStamp)
{
  let Service=this;
  if (this._started) 
  {
    var currentTime=this.ctx.currentTime;

   
    window.requestAnimationFrame(this.runTick.bind(this))
   if (this.beatFun)
   {
     if (Service.beatInterval==null)
     {
       Service.beatInterval=60/Service.tempo/2;
     }
     if (Service.beatTime ==0)// very first time
     {
      Service.beatTime=currentTime+Service.beatInterval;
      if (Service.beatTimeout)
       clearTimeout(Service.beatTimeout)
      Service.beatTimeout=setTimeout(Service.beatFun.bind(Service),0);
      return;
     }
    if (Service.timeExpired(currentTime, Service.beatTime,Service.beatInterval))
    {
      //console.log('Expired' , currentTime, ' '+Service.beatTime);

      Service.beatTime=currentTime+Service.beatInterval;
      return;
    }
    else if (Service.timeEq(currentTime, Service.beatTime,35/1000))
    {
      if (Service.beatTimeout)
      clearTimeout(Service.beatTimeout)
      Service.beatTime=Service.beatTime+Service.beatInterval;
      Service.beatTimeout=setTimeout(Service.beatFun.bind(Service),0);
   
      return;
    }
   }
   
   
  }
 
}

stopTick (){
  //Service._started=false;
  this.beatFun=null;
}
isRunning()
{
  if (this._started && this.beatFun)
  return (true);
  return (false);
}
timeExpired (curTime, schedTime,interval)
{
if (curTime >= (schedTime+interval ))
  return true;
return false;
}

timeEq=function (curTime, scheduledTime, delta)
{
  if ((scheduledTime -delta ) <= curTime && (curTime >=scheduledTime +delta))
   return (true);
  return false;
}

getBPMeasure()
{
  return this.beatsPerMeasure;
}
    

    

}
